export default __webpack_public_path__ + "static/media/HYD-14.8db6b8fe.webp";